import _extends from "@babel/runtime/helpers/extends";
import Box from "@material-ui/core/esm/Box";
import TextField from "@material-ui/core/esm/TextField";
import Typography from "@material-ui/core/esm/Typography";
import Autocomplete from "@material-ui/lab/esm/Autocomplete";
import { nanoid } from 'nanoid';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormElement } from 'components/Form';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from '../VehicleFormStyles';
import EU_CLASSES_ENGLISH from './eu_classes_en.json';
import EN_CLASSES_NORWEGIAN from './eu_classes_no.json';
const idSuffix = nanoid();
export default function EuClass({
  control
}) {
  const {
    classificationBox
  } = useStyles();
  const {
    t,
    i18n
  } = useTranslation();
  const [euClassesList, setEuClassesList] = useState(EN_CLASSES_NORWEGIAN);
  const getCodes = Object.keys(euClassesList);
  useEffect(() => {
    return isNorwegian(i18n) ? setEuClassesList(EN_CLASSES_NORWEGIAN) : setEuClassesList(EU_CLASSES_ENGLISH);
  }, [i18n]);
  const inputId = `euClass_${idSuffix}`;
  return /*#__PURE__*/React.createElement(FormElement, {
    title: t('vehicles.eu_class'),
    childId: inputId
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "euClass",
    defaultValue: null,
    control: control,
    rules: {
      required: true
    },
    render: ({
      onBlur,
      onChange,
      ...props
    }) => /*#__PURE__*/React.createElement(Autocomplete, _extends({
      defaultValue: null,
      placeholder: t('vehicles.eu_class'),
      options: getCodes,
      getOptionLabel: option => option,
      onChange: (_e, data) => onChange(data),
      onBlur: onBlur,
      style: {
        width: 300
      },
      renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: t('vehicles.eu_class'),
        variant: "outlined",
        InputProps: {
          ...params.InputProps,
          endAdornment: params.InputProps.endAdornment
        }
        // eslint-disable-next-line react/jsx-no-duplicate-props
        ,
        inputProps: {
          ...params.inputProps,
          id: inputId
        }
      })),
      renderOption: option => /*#__PURE__*/React.createElement(Box, {
        className: classificationBox
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1"
      }, option), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption"
      }, option ? euClassesList[option].codeDescription : ''))
    }, props))
  }));
}